module.exports = __webpack_public_path__ + "static/img/menu.de67add8.png";